import { render } from "./CommonPage.vue?vue&type=template&id=5c8ad03a"
import script from "./CommonPage.vue?vue&type=script&lang=js"
export * from "./CommonPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__